export function getStatusColor(status) {
    const statusColors = {
        1: "#22c55e",
        2: "#f8bb54",
        3: "#dc8e09",
        4: "#FF0000",
        5: "#36454F",
        6: "#FF0000",
        7: "#FF0000",
        8: "#3F3F3F",
        9: "#FF0000",
        10: "#FF0000",
    };

    return statusColors[status] || "#36454F";
}